import * as React from 'react';

import { Container, Col, Row } from 'react-bootstrap';

import { View, Text, rem, TouchableOpacity} from '../libs/WebComponents';
import { Props, TimeoutID } from '../types/types';
import ProgressBar from '../Components/ProgressBar';
import { WpPage } from '../App';
import parsePage from './parsePage';
import AppHeader from '../Components/AppHeader';
import BottomMenu from '../Components/BottomMenu';
import GeneralTipContainer from '../Components/GeneralTipContainer';
import pinpoint_arrow from './../svgs/pinpoint-fc-arrow.svg';

export const Page = (props: Props)=> {
   props = {
      type: 'default',
      body:null,
      children:null,
      index: 0,
      ...props
   }
   const [animate, setAnimate] = React.useState('animate');
   React.useEffect(()=>{
      setTimeout(()=>setAnimate(''),300);
      if (props.autoclose){
         setTimeout(_onClosePage, Number.isInteger(props.autoclose)?props.autoclose:5000);
      }
   },[]);

   const _onClosePage = ()=>{
      setAnimate('animate');
      setTimeout(props.onClose, 300);
   }


   return (
      <View className={`page zoomIn ${animate} ${props.type} `} role="page">
         {props.children}
      </View>
   );
};

const Pager = (props: Props) => {

   const [page, setPage] = React.useState<{page: WpPage, props: Props, View: JSX.Element}>();
   const [transition, setTransition] = React.useState(0);
   const [index, setIndex] = React.useState(0);
   const [canNext, setCanNext] = React.useState(true);
   const [showExplanationPage, setShowExplanationPage] = React.useState<null | Function>();

   const ref = React.useRef(null as null | HTMLDivElement);

   React.useEffect(()=>{
      let timeout: TimeoutID;
      if ((!page || props.index !==page.props.index))
      {
         setTransition(1);
         
         timeout = setTimeout(()=>{
            clearTimeout(timeout);
            setTransition(2);
            timeout = setTimeout(()=>{
               clearTimeout(timeout);
               const p = props.pages.find((_, i: number)=>i===props.index);
               if (p){
                  
                  setPage({page:p.page, props: p.props, View: parsePage(p.page, {...props,...p.props, index:props.index, setCanNext, setShowExplanationPage})});
                  if (ref.current) ref.current.scrollTop = 0;
                  //if (DEV) console.log(p.page.post_name);
                  setIndex(props.index);
                  setTransition(1);
               }
               timeout = setTimeout(()=>{
                  clearTimeout(timeout);
                  setTransition(0);
                  setTimeout(()=>globalThis.FAanimations.init(),10);

               },350);
            },350);
         }, 100);
      }

      return()=>{
         clearTimeout(timeout);
      };

   },[props.index]);

   if (!page) return null;

   let geolocation = index===0 && props.group.geolocation?props.group.geolocation:null;
   if (page.page.page_type=== 'chapter' && page.page.geolocation){
      geolocation = page.page.geolocation;
   }

   const has_progressbar = page.props.chapter || page.page.post_name ==='app-end';
   return props.pages.length>0?(
      <View ref={ref} className={`pager-container ${page.page.page_type?page.page.page_type:''}`}>
         {has_progressbar?(
         <Container style={{position:'relative', height:20, top:55, ...props.style}}>
            <Row className="justify-content-center">
               <Col className={'col-12 col-xl-10'}>
                  <ProgressBar index={index - props.chapters_start} total={props.chapter_pages_length}/>
               </Col>
            </Row>
         </Container>):null}

         <View className={`pager-page ${has_progressbar?'has-progress-bar':''} ${index!==0?'has-top-bar':''}`} style={{filter:transition===2?'blur(10px)':null}}>
            {page?page.View:null}
            {props.token?<View style={{minHeight:rem(10), maxHeight:rem(10)}}/>:null}
         </View>
         {transition!=0?<div className={`transition ${transition==2?'active':''}`}/>:null}
         {index!==0?<AppHeader title={props.group.title} index={index}/>:null}
         {page.props.chapter?<BottomMenu {...props} index={index} can_next={canNext} showExplanationPage={showExplanationPage} />:null}
         {index>0 && index < props.chapters_start?<GeneralTipContainer group={props.group} />:null}
         {geolocation?<View className={'home-location-label'}>
            <TouchableOpacity className={'inner'} onPress={()=>props.openLocationPopup(geolocation)}>
               <img src={pinpoint_arrow} alt="pinpoint" style={{width:rem(4)}} />
               <Text style={{fontSize:rem(1.1),color:'var(--bs-body-color'}}>Toon locatie</Text>
            </TouchableOpacity>
         </View>:null}
      </View>):null;
}


export default React.memo(Pager) ;